import { gql } from '@apollo/client';

export const UPSERT_SERVICE_CATEGORY = gql`
  mutation UpsertServiceCategory($input: UpsertServiceCategoryInput!) {
    serviceCategory: upsertServiceCategory(input: $input) {
      id
    }
  }
`;
